interface DatedReview {
  message: { leftAt?: string };
}

/** Merge sources by publication date without sorting either source. */
export function mergeReviewSources<T extends DatedReview>(turpravda: T[], site: T[]): T[] {
  const merged: T[] = [];
  let siteIndex = 0;
  const date = (review: T): number => {
    const value = Date.parse(review.message.leftAt || '');
    return Number.isNaN(value) ? -Infinity : value;
  };

  for (const partnerReview of turpravda) {
    while (siteIndex < site.length && date(site[siteIndex]) >= date(partnerReview)) {
      merged.push(site[siteIndex++]);
    }
    merged.push(partnerReview);
  }

  return [...merged, ...site.slice(siteIndex)];
}
